import React from 'react';
import { Page, Navbar, Link, Block, BlockTitle } from 'framework7-react';
import Graph from '../graph/Graph';


// const data = [
//     { day: '2018-10-01', type:"main", ambp: [98, 132] , pmbp:[84, 139] , ammc:1, nnmc:1, pmmc:1 , feelings:{feeling:1, conditions:[1,4], memo:1}},
//     { day: '2018-10-02', type:"main", ambp: [86, 130] , pmbp:[80, 131] , ammc:1, nnmc:1, pmmc:1 , feelings:{feeling:2, conditions:null, memo:null}},
//     { day: '2018-10-03', type:"main", ambp: [84, 128] , pmbp:[81, 135] , ammc:1, nnmc:null, pmmc:1, feelings:{feeling:3, conditions:null, memo:null}},
//     { day: '2018-10-04', type:"main", ambp: [79, 123] , pmbp:[86, 131] , ammc:1, nnmc:1, pmmc:1, feelings:{feeling:4, conditions:null, memo:null}},
//     { day: '2018-10-05', type:"main", ambp: [81, 130] , pmbp:[94, 132] , ammc:1, nnmc:1, pmmc:1, feelings:{feeling:5, conditions:[1,2,3,5,6], memo:1}},
//     { day: '2018-10-06', type:"main", ambp: [81, 132] , pmbp:[82, 128] , ammc:1, nnmc:1, pmmc:null, feelings:{feeling:1, conditions:[1,2,3,4,5,6], memo:1}},
//     { day: '2018-10-07', type:"main", ambp: [99, 139] , pmbp:[75, 140] , ammc:1, nnmc:1, pmmc:1, feelings:{feeling:5, conditions:[1,2,3,4,5,6], memo:1}},
// ];

// const dataBPM = [
//     { day: '2018-10-01 09:00:00', type:"BPM", period: 'am', bpm:51},
//     { day: '2018-10-01 14:00:00', type:"BPM", period: 'pm', bpm:60},
//     { day: '2018-10-02 09:00:00', type:"BPM", period: 'am', bpm:49},
//     { day: '2018-10-02 14:00:00', type:"BPM", period: 'pm', bpm:62},
//     { day: '2018-10-03 09:00:00', type:"BPM", period: 'am', bpm:50},
//     { day: '2018-10-03 14:00:00', type:"BPM", period: 'pm', bpm:69},
//     { day: '2018-10-04 09:00:00', type:"BPM", period: 'am', bpm:59},
//     { day: '2018-10-04 14:00:00', type:"BPM", period: 'pm', bpm:71},
//     { day: '2018-10-05 09:00:00', type:"BPM", period: 'am', bpm:null},
//     { day: '2018-10-05 14:00:00', type:"BPM", period: 'pm', bpm:63},
//     { day: '2018-10-06 09:00:00', type:"BPM", period: 'am', bpm:51},
//     { day: '2018-10-06 14:00:00', type:"BPM", period: 'pm', bpm:62},
//     { day: '2018-10-07 09:00:00', type:"BPM", period: 'am', bpm:53},
//     { day: '2018-10-07 14:00:00', type:"BPM", period: 'pm', bpm:59},
// ];

// const dataWeight = [
//     { day: '2018-10-01 09:00:00', type:"weight", period: 'am', weight:70.1},
//     { day: '2018-10-01 14:00:00', type:"weight", period: 'pm', weight:70.5},
//     { day: '2018-10-02 09:00:00', type:"weight", period: 'am', weight:70.6},
//     { day: '2018-10-02 14:00:00', type:"weight", period: 'pm', weight:70.9},
//     { day: '2018-10-03 09:00:00', type:"weight", period: 'am', weight:71.1},
//     { day: '2018-10-03 14:00:00', type:"weight", period: 'pm', weight:71.5},
//     { day: '2018-10-04 09:00:00', type:"weight", period: 'am', weight:71.2},
//     { day: '2018-10-04 14:00:00', type:"weight", period: 'pm', weight:71.5},
//     { day: '2018-10-05 09:00:00', type:"weight", period: 'am', weight:71.7},
//     { day: '2018-10-05 14:00:00', type:"weight", period: 'pm', weight:72.0},
//     { day: '2018-10-06 09:00:00', type:"weight", period: 'am', weight:null},
//     { day: '2018-10-06 14:00:00', type:"weight", period: 'pm', weight:72.3},
//     { day: '2018-10-07 09:00:00', type:"weight", period: 'am', weight:72.1},
//     { day: '2018-10-07 14:00:00', type:"weight", period: 'pm', weight:72.8},
// ];

let data = [];
let dataBPM = [];
let dataWeight = [];
let fromDate = new Date('2018-10-1');

for(var i=0;i<30;i++)
{
    var date = new Date(formatDate(fromDate));
    date.setDate(date.getDate() + i);

    const day = formatDate(date);
    data.push({
                day: day, 
                type:"main",
                ambp: [getRandomNumber(40,99,0), getRandomNumber(100,150,0)] , 
                pmbp:[getRandomNumber(40,99,0), getRandomNumber(100,150,0)] , 
                ammc:getRandomTrueFalse(),
                nnmc:getRandomTrueFalse(),
                pmmc:getRandomTrueFalse(),
                feelings:{
                    feeling:getRandomNumber(1,5,0), 
                    conditions:getRandomConditioins(), 
                    memo:getRandomTrueFalse()
                }
            });

    dataBPM.push(
        {
            day: day + " 09:00:00", 
            type:"BPM",
            period: 'am',
            bpm:getRandomNumber(30,85,0), 
        }
    );

    dataBPM.push(
        {
            day: day + " 14:00:00", 
            type:"BPM",
            period: 'pm',
            bpm:getRandomNumber(30,85,0), 
        }
    );

    dataWeight.push(
        {
            day: day + " 09:00:00", 
            type:"weight",
            period: 'am',
            weight: getRandomNumber(70,75,1), 
        }
    );

    dataWeight.push(
        {
            day: day + " 14:00:00", 
            type:"weight",
            period: 'pm',
            weight: getRandomNumber(70,75,1),
        }
    );
}

function getRandomNumber(low, high, decimals)
{
    var result = Math.random() * (high - low) + low;
    if(decimals == 0)
    {
        return parseInt(result);
    }

    return parseFloat(result.toFixed(decimals));
}

function getRandomTrueFalse()
{
    const result = getRandomNumber(0,2,0);
    if(result == 0)
    {
        return null;
    }

    return result;
}

function getRandomConditioins()
{
    const result = getRandomNumber(0,2,0);
    switch(result)
    {
        case 0:
            return null;
            break;
        case 1:
            return [1,3,4];
            break;
        case 2:
            return [2,3,4,5];
            break;
        case 3:
            return [1,2,3,4,5,6];
            break;
    }
}

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

//conditions 1:Dry Cough 2:Migraine 3:Dizziness 4:Heart Palpitations 5:Hot Flashes 6:Swelling

//用来设置是否显示某个时期的medication
const medicationPeriod = {morning:true, noon:true, evening: true};
// var medicationPeriodCount = 0;

// medicationPeriodCount += medicationPeriod.morning ? 1 : 0;
// medicationPeriodCount += medicationPeriod.noon ? 1 : 0;
// medicationPeriodCount += medicationPeriod.evening ? 1 : 0;


export default () => (
    <Page>
        <div>
            {/* <Graph
                data={data}
                dataBPM={dataBPM}
                dataWeight={dataWeight}
                medicationPeriod={medicationPeriod}
            /> */}
            <Graph/>
        </div>

    </Page>
);



// WEBPACK FOOTER //
// ./src/components/pages/HomePage.jsx